import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { gungCheckAndDownloadFile, GungNotificationService, PresignedUrlRequest, S3UploadService } from 'gung-common';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerDocumentsService {
  private baseUrl = 'json/document-relations';
  documentsUpdated = new BehaviorSubject<string>('');

  constructor(
    private http: HttpClient,
    protected s3Upload: S3UploadService,
    protected gungNotificationService: GungNotificationService,
    protected translateService: TranslateService
  ) {}

  getDocuments(relationId: string, nocache?: boolean): Observable<DocumentRelation[]> {
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };

    return this.http.get<DocumentRelation[]>(this.baseUrl, {
      headers,
      params: new HttpParams().set('relationIds', relationId)
    });
  }

  downloadDocument(document: DocumentRelation): void {
    this.http.post<{ url: string }>(`json/s3/presigned-urls/download`, { key: document.s3Uri }).subscribe({
      next: response => {
        gungCheckAndDownloadFile(this.http, response.url, document.name);
      },
      error: err => console.error('error:', err)
    });
  }

  uploadDocument(event: any, customerId: string): void {
    const input = event.target as HTMLInputElement;
    const randon = this.generateRandomString(8);
    let request: PresignedUrlRequest = {
      key: `customer-documents/${customerId}/${randon}/${input.files[0].name}`,
      appendCustomerPrefix: true
    };
    this.s3Upload.presignedUrlUpload(request).subscribe(s3Url => {
      const file = event.target.files[0];
      this.s3Upload.uploadFile(file, s3Url.url).subscribe(etag => {
        console.log(request);
        console.log(etag);
        const payload = {
          s3Uri: s3Url.s3Key,
          s3Etag: etag,
          s3Bucket: s3Url.s3Bucket,
          relationIds: ['customer:' + customerId],
          documentType: 'Document'
        };
        this.s3Upload.createFileRelation(payload).subscribe(_ => {
          this.documentsUpdated.next(payload.s3Etag);
          this.gungNotificationService.notify(this.translateService.instant('UPLOAD_DOCUMENT_SUCCESS'), null, 'success');
        });
      });
    });
  }

  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }

  deleteDocument(id: string): Observable<string> {
    return this.http.delete<string>(`${this.baseUrl}/${id}`).pipe(
      tap(_ => {
        this.documentsUpdated.next(id);
        this.gungNotificationService.notify(this.translateService.instant('DELETE_DOCUMENT_SUCCESS'), null, 'success');
      })
    );
  }
}

export interface DocumentRelation {
  id: string;
  name: string;
  s3Bucket: string;
  s3Uri: string;
  s3Etag: string;
  relationIds: string[];
}
